type DiscountType = "percentage" | "currency";

/** Apply a discount to a gross price. Unrounded — caller owns rounding policy. */
export function applyDiscount(
  price: number,
  type: DiscountType,
  amount: number
): number {
  return type === "percentage"
    ? price - price * (amount / 100)
    : price - amount;
}
